import React, { useState } from 'react';
import LayoutHomepage from '../layout/LayoutHomepage';
import Container from '../components/misc/Container';
import { Link } from 'react-router-dom';
import DynamicScrollToTop from '../components/misc/DynamicScrollToTop';

// Import Icon
import { ReactComponent as BurgerIcon } from '../assets/icons/burder-icon.svg';
import { ReactComponent as ArrowRightIcon } from '../assets/icons/arrow-right-ico.svg';
import Vegetable from '../components/Category/TabCategory/Vegetable';
import Meat from '../components/Category/TabCategory/Meat';
import Groceries from '../components/Category/TabCategory/Groceries';
import Seasoning from '../components/Category/TabCategory/Seasoning';
import Fruit from '../components/Category/TabCategory/Fruit';
import Processed from '../components/Category/TabCategory/Processed';
import Food from '../components/Category/TabCategory/Food';
import Drink from '../components/Category/TabCategory/Drink';
import Fish from '../components/Category/TabCategory/Fish';

const Category = () => {
  const [showTabCategory, setShowTabCategory] = useState('vegetable');
  let contentCategory = <div> Empty </div>;
  switch (showTabCategory) {
    case 'vegetable':
      contentCategory = <Vegetable />;
      break;
    case 'meat':
      contentCategory = <Meat />;
      break;
    case 'groceries':
      contentCategory = <Groceries />;
      break;
    case 'seasoning':
      contentCategory = <Seasoning />;
      break;
    case 'fruit':
      contentCategory = <Fruit />;
      break;
    case 'fish':
      contentCategory = <Fish />;
      break;
    case 'processed':
      contentCategory = <Processed />;
      break;
    case 'food':
      contentCategory = <Food />;
      break;
    case 'drink':
      contentCategory = <Drink />;
      break;

    default:
      break;
  }
  return (
    <>
      <DynamicScrollToTop />
      <LayoutHomepage>
        <div className="flex flex-col w-full mt-32">
          {/* Content */}
          <Container>
            <div className="flex flex-col w-full">
              <div className="flex w-full mt-8 mb-2">
                <p className="flex items-center text-font-gray opacity-50">
                  <Link to="/homepage">Beranda </Link>
                  <ArrowRightIcon className="h-3 w-3 mx-2" />
                </p>
                <p className="text-font-gray ">Sayuran</p>
              </div>
            </div>
          </Container>
          <Container>
            <div className="flex flex-col w-2/12 pr-4 mb-8">
              <div className="flex w-full border-b border-gray-200 pb-1">
                <button className="text-lg text-font-gray font-semibold flex py-2 items-center w-full">
                  {' '}
                  <BurgerIcon className="w-4 h-4" />
                  <p className="ml-auto">Semua Sayuran</p>
                </button>
              </div>
              <div className="flex-w-full pt-2">
                <ul className="w-9/12 ml-auto ">
                  <li
                    className={
                      ' py-2 transition ease-in-out duration-300 cursor-pointer ' +
                      (showTabCategory === 'vegetable'
                        ? ' text-basic-orange'
                        : 'text-font-gray hover:text-basic-orange ')
                    }
                    onClick={() => setShowTabCategory('vegetable')}
                  >
                    <p>Sayuran</p>
                  </li>
                  <li
                    className={
                      ' py-2 transition ease-in-out duration-300 cursor-pointer ' +
                      (showTabCategory === 'meat'
                        ? ' text-basic-orange'
                        : 'text-font-gray hover:text-basic-orange ')
                    }
                    onClick={() => setShowTabCategory('meat')}
                  >
                    <p>Daging</p>
                  </li>
                  <li
                    className={
                      ' py-2 transition ease-in-out duration-300 cursor-pointer ' +
                      (showTabCategory === 'groceries'
                        ? ' text-basic-orange'
                        : 'text-font-gray hover:text-basic-orange ')
                    }
                    onClick={() => setShowTabCategory('groceries')}
                  >
                    <p>Sembako</p>
                  </li>
                  <li
                    className={
                      ' py-2 transition ease-in-out duration-300 cursor-pointer ' +
                      (showTabCategory === 'seasoning'
                        ? ' text-basic-orange'
                        : 'text-font-gray hover:text-basic-orange ')
                    }
                    onClick={() => setShowTabCategory('seasoning')}
                  >
                    <p>Bumbu</p>
                  </li>
                  <li
                    className={
                      ' py-2 transition ease-in-out duration-300 cursor-pointer ' +
                      (showTabCategory === 'fruit'
                        ? ' text-basic-orange'
                        : 'text-font-gray hover:text-basic-orange ')
                    }
                    onClick={() => setShowTabCategory('fruit')}
                  >
                    <p>Buah</p>
                  </li>
                  <li
                    className={
                      ' py-2 transition ease-in-out duration-300 cursor-pointer ' +
                      (showTabCategory === 'fish'
                        ? ' text-basic-orange'
                        : 'text-font-gray hover:text-basic-orange ')
                    }
                    onClick={() => setShowTabCategory('fish')}
                  >
                    <p>Ikan</p>
                  </li>
                  <li
                    className={
                      ' py-2 transition ease-in-out duration-300 cursor-pointer ' +
                      (showTabCategory === 'processed'
                        ? ' text-basic-orange'
                        : 'text-font-gray hover:text-basic-orange ')
                    }
                    onClick={() => setShowTabCategory('processed')}
                  >
                    <p>Olahan</p>
                  </li>
                  <li
                    className={
                      ' py-2 transition ease-in-out duration-300 cursor-pointer ' +
                      (showTabCategory === 'food'
                        ? ' text-basic-orange'
                        : 'text-font-gray hover:text-basic-orange ')
                    }
                    onClick={() => setShowTabCategory('food')}
                  >
                    <p>Makanan</p>
                  </li>
                  <li
                    className={
                      ' py-2 transition ease-in-out duration-300 cursor-pointer ' +
                      (showTabCategory === 'drink'
                        ? ' text-basic-orange'
                        : 'text-font-gray hover:text-basic-orange ')
                    }
                    onClick={() => setShowTabCategory('drink')}
                  >
                    <p>Minuman</p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="flex flex-col w-10/12 pl-6 mb-8">
              {contentCategory}
            </div>
          </Container>
          {/* End Content */}
        </div>
      </LayoutHomepage>
    </>
  );
};

export default Category;
